import type { ColumnType, Generated, Selectable } from 'kysely'
import z from 'zod'

import {
  nanoidSchema,
  docVersionSchema as versionStringSchema,
} from '@/utility'

export const embedStatuses = ['pending', 'success', 'failed'] as const

export type EmbedStatus = (typeof embedStatuses)[number]

export type VersionEntity = {
  id: Generated<string>
  uid: string
  semver: string
  documentId: string
  raw: Uint8Array
  embedStatus: ColumnType<EmbedStatus, EmbedStatus | undefined, EmbedStatus>
  createdAt: ColumnType<Date, Date | undefined, never>
  updatedAt: ColumnType<Date, never, Date>
}

export type Version = Selectable<VersionEntity>

export const versionSchema = z
  .object({
    id: z.uuid(),
    uid: nanoidSchema,
    semver: versionStringSchema,
    documentId: z.uuid(),
    raw: z.instanceof(Uint8Array),
    embedStatus: z.enum(embedStatuses),
    createdAt: z.date(),
    updatedAt: z.date(),
  })
  .meta({ id: 'version' }) satisfies z.ZodType<Version>
